// Projects data.
// Note: Here we are getting data from a js file, but in a different project I'll be fetching these projects from some srt of APIs.

const projects = [
	{
		id: 1,
		title: 'Soulmap',
		category: 'aScriptingOreo',
		img: require('@/assets/images/Soulmap.png'),
		url: 'https://soulmap.avakot.org/',
	},
	{
		id: 2,
		title: 'Soulframe Plus',
		category: 'elvimine',
		img: require('@/assets/images/soulframeplus.png'),
		url: 'https://www.appsheet.com/start/38410899-f3a8-4362-9312-921cd89718ca',
	},
];

export default projects;
